<div class="container-fluid">
  <app-content-tab-list [activeTab]="activeTabIndex" type="marketplace" category="Marketplace"></app-content-tab-list>

  <div class="row section1 justify-content-between mt-4">
    <div class="col-12 col-md-auto">
      <div class="home-details">
        <h5 class="home-title">{{entityLabelPlural}} ({{projects.length}})</h5>
        <p class="home-subtitle">Manage marketplace {{entityLabelPlural.toLowerCase()}} and roles from here</p>
      </div>
    </div>
    <div class="col-12 col-md-auto">
      <button class="btn btn-primary btn-dashboard" (click)="openCreateModal()">
        <i class="las la-plus-circle"></i>Add {{entityLabel}}
      </button>
    </div>
  </div>

  <div class="row section1">
    <div class="col-12">
      <div class="projects-filters-card">
        <div class="projects-filters-title">Filter {{entityLabelPlural}}</div>
        <div class="projects-filters-grid">
          <div class="projects-filter-item projects-filter-item-wide">
            <label class="projects-filter-label">Keyword</label>
            <input type="text"
              class="form-control"
              [(ngModel)]="filters.keyword"
              (keydown)="handleFilterInputKeyDown($event)"
              placeholder="{{entityLabel}} name, description or twitter"/>
          </div>
          <div class="projects-filter-item">
            <label class="projects-filter-label">Status</label>
            <select class="form-control" [(ngModel)]="filters.status">
              <option value="all">All</option>
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </select>
          </div>
          <div class="projects-filter-actions">
            <button class="btn projects-filter-apply-btn ml-0" (click)="applyFilters()">Apply Filters</button>
            @if (hasActiveFilters()) {
              <button class="btn btn-outline-secondary ml-2" (click)="clearFilters()">Reset</button>
            }
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row section1">
    <div class="col-12">
      <div class="table-responsive applicants-details overflow-x-visible">
        <table class="table table-bordered user-table">
          <thead>
            <tr>
              <th scope="col">ID</th>
              <th scope="col">Icon</th>
              <th scope="col">{{entityLabel}}</th>
              @if (!isSatire) {
                <th scope="col">Website</th>
              }
              <th scope="col">Roles</th>
              <th scope="col">Status</th>
              <th scope="col">Updated At</th>
              <th scope="col">Actions</th>
            </tr>
          </thead>
          @if (!loading && filteredProjects.length) {
            <tbody>
              @for (project of filteredProjects | paginate: { itemsPerPage: perPage, currentPage: page, totalItems: filteredProjects.length, id:'marketplace-projects'}; track project) {
                <tr class="client"
                  >
                  <td class="text-nowrap" [attr.title]="(project.id || '').toUpperCase()"><span>{{(project.id || '').slice(-6).toUpperCase()}}</span>
                  <i (click)="handleCopyToClipboard(project.id);" class="las la-copy la-lg pointer copy-icon"></i>
                </td>
                <td>
                  <img [src]="project.iconKey || 'assets/images/placeholder.png'"
                    class="project-icon-thumb"
                    onerror="this.src='assets/images/placeholder.png'"
                    alt="">
                </td>
                <td>
                  <div class="project-title">{{project.name || 'NA'}}</div>
                  <div class="project-subtitle">{{project.description || 'No description'}}</div>
                </td>
                @if (!isSatire) {
                  <td>
                    @if (project.websiteUrl) {
                      <a [href]="project.websiteUrl" target="_blank" rel="noreferrer">
                        {{project.websiteUrl}}
                      </a>
                    }
                    @if (!project.websiteUrl) {
                      <span class="text-muted">NA</span>
                    }
                  </td>
                }
                <td>
                  <span class="project-role-count">{{project.roles?.length || 0}} roles</span>
                </td>
                <td>
                  <span class="project-status" [ngClass]="project.isActive ? 'status-active' : 'status-inactive'">
                    {{project.isActive ? 'active' : 'inactive'}}
                  </span>
                </td>
                <td>{{project.updatedAt | date:'medium'}}</td>
                <td class="action">
                  <div class="dropdown">
                    <button type="button" class="btn header-item waves-effect btn-dropdown"
                      data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                      <a class="mr-3 text-primary py-2 text-nowrap">
                        View actions <i class="las mb-1 la-angle-down align-middle mr-0"></i></a>
                      </button>
                      <div class="dropdown-menu dropdown-menu-right animate slideIn side-menu-dropdown py-0 rounded-1">
                        <a class="dropdown-item text-info border-bottom py-2 text-nowrap" (click)="openEditModal(project)">
                          <i class="las la-edit mb-1 la-lg align-middle mr-0"></i> Edit</a>
                          <a
                            class="dropdown-item text-danger py-2 text-nowrap"
                            (click)="deleteProject(project)">
                            <i class="las la-trash-alt mb-1 la-lg align-middle mr-0"></i> Delete</a>
                            </div>
                          </div>
                        </td>
                      </tr>
                    }
                  </tbody>
                }
                @if (loading) {
                  <tbody>
                    @for (q of loaders; track q) {
                      <tr>
                        <td><ngx-skeleton-loader [theme]="{height:'40px', width:'160px', marginBottom: '0px'}"></ngx-skeleton-loader></td>
                        <td><ngx-skeleton-loader [theme]="{height:'48px', width:'48px', marginBottom: '0px'}"></ngx-skeleton-loader></td>
                        <td><ngx-skeleton-loader [theme]="{height:'40px', width:'220px', marginBottom: '0px'}"></ngx-skeleton-loader></td>
                        @if (!isSatire) {
                          <td><ngx-skeleton-loader [theme]="{height:'40px', width:'200px', marginBottom: '0px'}"></ngx-skeleton-loader></td>
                        }
                        <td><ngx-skeleton-loader [theme]="{height:'40px', width:'90px', marginBottom: '0px'}"></ngx-skeleton-loader></td>
                        <td><ngx-skeleton-loader [theme]="{height:'40px', width:'90px', marginBottom: '0px'}"></ngx-skeleton-loader></td>
                        <td><ngx-skeleton-loader [theme]="{height:'40px', width:'140px', marginBottom: '0px'}"></ngx-skeleton-loader></td>
                        <td><ngx-skeleton-loader [theme]="{height:'40px', width:'100px', marginBottom: '0px'}"></ngx-skeleton-loader></td>
                      </tr>
                    }
                  </tbody>
                }
              </table>
            </div>
            @if (!loading && !filteredProjects.length) {
              <div class="d-flex align-items-center justify-content-center py-5">
                No {{entityLabelPlural.toLowerCase()}} found
              </div>
            }
            <div class="float-right mt-3">
              <pagination-controls (pageChange)="pageChange($event)" id="marketplace-projects"></pagination-controls>
            </div>
          </div>
        </div>
      </div>

      @if (showProjectModal) {
        <div class="modal fade show marketplace-project-modal" tabindex="-1" role="dialog" [ngStyle]="{'display': 'block'}" (click)="closeProjectModal()">
          <div class="modal-dialog modal-xl modal-dialog-centered" role="document" (click)="$event.stopPropagation()">
            <div class="modal-content marketplace-project-modal-content">
              <div class="modal-header marketplace-project-modal-header">
                <div>
                  <h5 class="modal-title marketplace-project-modal-title">{{isEditMode ? ('Edit ' + entityLabel) : ('Add ' + entityLabel)}}</h5>
                </div>
                <button type="button" class="close marketplace-project-close-btn" aria-label="Close" (click)="closeProjectModal()">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body marketplace-project-modal-body">
                <div class="project-form-grid">
                  <div class="project-icon-field">
                    <label class="project-label">{{entityLabel}} Icon <span>*</span></label>
                    <div class="project-icon-upload" (click)="handleIconUploadClick()">
                      @if (projectForm.iconKey && !uploadingIcon) {
                        <img [src]="projectForm.iconKey" alt="">
                      }
                      @if (!projectForm.iconKey && !uploadingIcon) {
                        <img src="assets/images/placeholder.png" alt="">
                      }
                      @if (uploadingIcon) {
                        <div class="project-icon-loader">
                          <img src="assets/images/loading.gif" width="42" alt="">
                        </div>
                      }
                      <button type="button" class="btn btn-sm btn-outline-primary mt-2" [disabled]="uploadingIcon">
                        {{projectForm.iconKey ? 'Change Icon' : 'Upload Icon'}}
                      </button>
                    </div>
                    <input id="project_icon_upload"
                      type="file"
                      accept=".png, .jpg, .jpeg, .webp, .svg"
                      class="form-control d-none"
                      (change)="uploadIcon($event)">
                  </div>
                  <div class="project-form-fields">
                    <div class="row">
                      <div class="col-12 col-lg-8">
                        <label class="project-label">{{entityLabel}} Name <span>*</span></label>
                        <input type="text" class="form-control" [(ngModel)]="projectForm.name" placeholder="Enter {{entityLabel.toLowerCase()}} name">
                      </div>
                      <div class="col-12 col-lg-4 mt-3 mt-lg-0">
                        <label class="project-label">Status</label>
                        <select class="form-control" [(ngModel)]="projectForm.isActive">
                          <option [ngValue]="true">Active</option>
                          <option [ngValue]="false">Inactive</option>
                        </select>
                      </div>
                      <div class="col-12 mt-3">
                        <label class="project-label">{{entityLabel}} Description <span>*</span></label>
                        <textarea class="form-control project-description-input"
                          [(ngModel)]="projectForm.description"
                        placeholder="Enter {{entityLabel.toLowerCase()}} description"></textarea>
                      </div>
                      @if (!isSatire) {
                        <div class="col-12 col-lg-8 mt-3">
                          <label class="project-label">Project Website URL <span>*</span></label>
                          <input type="url" class="form-control" [(ngModel)]="projectForm.websiteUrl" placeholder="https://project.website">
                        </div>
                      }
                      <div class="col-12 col-lg-4 mt-3" [class.col-lg-8]="isSatire">
                        <label class="project-label">Twitter URL</label>
                        <input type="url" class="form-control" [(ngModel)]="projectForm.twitterUrl" placeholder="https://x.com/...">
                      </div>
                    </div>
                  </div>
                </div>
                <details class="project-optional-panel mt-4" open>
                  <summary>
                    <span>Roles</span>
                    <i class="las la-angle-down"></i>
                  </summary>
                  <div class="project-optional-panel-body">
                    <div class="project-roles-header">
                      <h6 class="mb-0">Manage Roles</h6>
                      <button type="button" class="btn btn-sm btn-outline-primary" (click)="addRole()">+ Add Role</button>
                    </div>
                    <div class="project-role-table">
                      <div class="project-role-row role-head">
                        <div>Role Name</div>
                        <div>Role Description</div>
                        <div class="text-center">Apply</div>
                        <div class="text-center">Fulfilled</div>
                        <div class="text-center">Sort</div>
                        <div class="text-center">Action</div>
                      </div>
                      @for (role of projectForm.roles; track role; let i = $index) {
                        <div class="project-role-row">
                          <div>
                            <input type="text" class="form-control" [(ngModel)]="role.name" [name]="'roleName' + i" placeholder="Role Name">
                          </div>
                          <div>
                            <input type="text" class="form-control" [(ngModel)]="role.description" [name]="'roleDesc' + i" placeholder="Role Description">
                          </div>
                          <div class="text-center">
                            <input type="checkbox" [(ngModel)]="role.isApplyEnabled" [name]="'roleApply' + i">
                          </div>
                          <div class="text-center">
                            <input type="checkbox" [(ngModel)]="role.isFulfilled" [name]="'roleFulfilled' + i">
                          </div>
                          <div class="text-center">
                            <input type="number" class="form-control text-center role-sort-input" [(ngModel)]="role.sortOrder" [name]="'roleSort' + i" min="0">
                          </div>
                          <div class="text-center">
                            <button type="button" class="role-row-btn danger" (click)="removeRole(i)">&times;</button>
                          </div>
                        </div>
                      }
                    </div>
                    <small class="text-muted mt-2 d-block">Roles with Apply disabled will not show apply option to Bhakts.</small>
                  </div>
                </details>
              </div>
              <div class="modal-footer marketplace-project-modal-footer">
                <button type="button" class="btn btn-outline-secondary" [disabled]="saving || uploadingIcon" (click)="closeProjectModal()">Cancel</button>
                <button type="button" class="btn btn-primary btn-dashboard ml-0" [disabled]="saving || uploadingIcon" (click)="saveProject()">
                  {{saving ? 'Saving...' : (isEditMode ? ('Update ' + entityLabel) : ('Add ' + entityLabel))}}
                </button>
              </div>
            </div>
          </div>
        </div>
      }
      @if (showProjectModal) {
        <div class="modal-backdrop fade show"></div>
      }
